module.exports = __webpack_public_path__ + "img/Groupe 74.91b25ab5.svg";